import { useEffect, useState } from 'react';

type UsePortalContainerProps = {
  id: string;
};

export const usePortalContainer = ({ id }: UsePortalContainerProps): HTMLDivElement | null => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    const newContainer = document.createElement('div');

    newContainer.id = id;
    document.body.appendChild(newContainer);

    setContainer(newContainer);

    return () => {
      if (newContainer) {
        newContainer.remove();
      }
    };
  }, []);

  return container;
};
